export const UPDATE_DEATH_CLAIM_DETAIL = 'UPDATE_DEATH_CLAIM_DETAIL';

export const updateDeathClaimDetail = (payload) => {
    return {
        type: UPDATE_DEATH_CLAIM_DETAIL,
        payload
    };
}
